/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function getSwatchAvailability(container, variantIds) {
  const productJsonEl = container.querySelector('[data-product-json]');
  if (!productJsonEl) return true;

  let product;
  try {
    product = JSON.parse(productJsonEl.textContent);
  } catch (e) {
    return true;
  }

  return product.variants.some(
    (v) => variantIds.includes(v.id) && v.available
  );
}

function correctSwatch(swatchButton, container) {
  const label = swatchButton.querySelector('[data-swatch-variant]');
  if (!label) return;

  const variantIds = label.getAttribute('data-swatch-variant')
    .split(',')
    .map((id) => parseInt(id, 10));

  const anyAvailable = getSwatchAvailability(container, variantIds);

  // Prevent infinite mutation loop by only touching classList when needed
  const hasSoldOut = swatchButton.classList.contains('sold-out');
  const hasUnavailable = swatchButton.classList.contains('unavailable');

  if (anyAvailable && (hasSoldOut || hasUnavailable)) {
    swatchButton.classList.remove('sold-out', 'unavailable');
  } else if (!anyAvailable && !hasSoldOut) {
    swatchButton.classList.remove('unavailable');
    swatchButton.classList.add('sold-out');
  }
}

function initSwatchAvailabilityFix(container) {
  const swatchButtons = container.querySelectorAll('[data-swatches-container] .swatch__button');
  if (!swatchButtons.length) return;

  // Correct immediately on load
  swatchButtons.forEach((btn) => correctSwatch(btn, container));

  // Watch for native script re-adding wrong classes, and correct on every mutation
  swatchButtons.forEach((btn) => {
    const observer = new MutationObserver(() => {
      correctSwatch(btn, container);
    });
    observer.observe(btn, { attributes: true, attributeFilter: ['class'] });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product]').forEach(initSwatchAvailabilityFix);
});

  // === PDP Gallery Arrows: hover-reveal by side, clean circles ===
  function styleArrow(arrow) {
    arrow.style.setProperty('opacity', '0', 'important');
    arrow.style.setProperty('transition', 'opacity .2s ease', 'important');
    arrow.style.setProperty('width', '36px', 'important');
    arrow.style.setProperty('height', '36px', 'important');
    arrow.style.setProperty('background-color', 'rgba(0,0,0,.2)', 'important');
    arrow.style.setProperty('fill', 'rgb(255,255,255)', 'important');
    arrow.style.setProperty('box-shadow', '0 1px 4px rgba(0,0,0,.12)', 'important');
    var svg = arrow.querySelector('svg');
    if (svg) {
      svg.setAttribute('width', '14');
      svg.setAttribute('height', '14');
    }
    if (arrow.classList.contains('pwzrswiper-btn-next')) {
      arrow.style.setProperty('right', '12px', 'important');
    } else {
      arrow.style.setProperty('left', '12px', 'important');
    }
    arrow.dataset.styled = '1';
  }

  // === PDP Gallery: 4:5 aspect ratio with cover ===
  function styleSlides() {
    var wrapper = document.getElementById('pwzrswiper-container-wrapper');
    if (!wrapper) return;

    wrapper.querySelectorAll('.pwzrswiper-slide').forEach(function(slide) {
      if (slide.dataset.ratio) return;
      slide.style.setProperty('padding-bottom', '125%', 'important');
      slide.dataset.ratio = '1';
    });

    wrapper.querySelectorAll('.pwzrswiper-slide img').forEach(function(img) {
      if (img.dataset.cover) return;
      img.style.setProperty('position', 'absolute', 'important');
      img.style.setProperty('top', '0', 'important');
      img.style.setProperty('left', '0', 'important');
      img.style.setProperty('width', '100%', 'important');
      img.style.setProperty('height', '100%', 'important');
      img.style.setProperty('object-fit', 'cover', 'important');
      img.dataset.cover = '1';

      var src = img.getAttribute('src') || img.getAttribute('data-src');
      if (src && !img.getAttribute('srcset')) {
        var base = src.replace(/[?&]width=\d+/, '');
        var sep = base.indexOf('?') > -1 ? '&' : '?';
        img.setAttribute('srcset',
          base + sep + 'width=1200 600w, ' +
          base + sep + 'width=1600 800w, ' +
          base + sep + 'width=1980 990w'
        );
        img.setAttribute('sizes', '(max-width: 767px) 100vw, 50vw');
      }
    });

    var swiperWrapper = document.getElementById('pwzrswiper-wrapper');
    if (swiperWrapper) {
      swiperWrapper.style.setProperty('height', 'auto', 'important');
    }
  }

  // === PDP Gallery: slim line slide indicators ===
  function injectSlimIndicatorCSS() {
    if (document.getElementById('ss-slim-indicators')) return;
    var style = document.createElement('style');
    style.id = 'ss-slim-indicators';
    style.textContent = [
      '#pwzrswiper-container-wrapper .pwzrswiper-pagination {',
      '  position: absolute !important;',
      '  bottom: 10px !important;',
      '  left: 0 !important;',
      '  right: 0 !important;',
      '  width: 100% !important;',
      '  display: flex !important;',
      '  align-items: center !important;',
      '  justify-content: center !important;',
      '  gap: 4px !important;',
      '  padding: 0 16px !important;',
      '  z-index: 10 !important;',
      '  box-sizing: border-box !important;',
      '}',
      '#pwzrswiper-container-wrapper .pwzrswiper-pagination-bullet {',
      '  width: auto !important;',
      '  height: 2px !important;',
      '  flex: 1 !important;',
      '  max-width: 32px !important;',
      '  border-radius: 2px !important;',
      '  background: rgba(255,255,255,0.4) !important;',
      '  margin: 0 !important;',
      '  opacity: 1 !important;',
      '  transition: background 0.25s ease !important;',
      '}',
      '#pwzrswiper-container-wrapper .pwzrswiper-pagination-bullet-active {',
      '  background: rgba(255,255,255,0.92) !important;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function styleAll() {
    var wrapper = document.getElementById('pwzrswiper-container-wrapper');
    if (wrapper) {
      wrapper.querySelectorAll('.pwzrswiper-btn-prev, .pwzrswiper-btn-next').forEach(function(a) {
        if (a.dataset.styled !== '1') styleArrow(a);
      });
      styleSlides();
      injectSlimIndicatorCSS();
    }

    hideLinerSelector();
    hideCartWalletGrid();

    // === Cart: Shop Pay only ===
    var acc = document.querySelector('shopify-accelerated-checkout-cart');
    if (acc && !acc.dataset.filtered) {
      acc.dataset.filtered = '1';
      try {
        var configs = JSON.parse(acc.getAttribute('wallet-configs'));
        var shopPayOnly = configs.filter(function(c) { return c.name === 'shop_pay'; });
        acc.setAttribute('wallet-configs', JSON.stringify(shopPayOnly));
      } catch(e) {}
      // Remove non-Shop Pay button elements
      ['shopify-amazon-pay-button', 'shopify-paypal-button', 'shopify-google-pay-button'].forEach(function(tag) {
        var el = acc.querySelector(tag);
        if (el) el.remove();
      });
    }
  }

  new MutationObserver(styleAll)
    .observe(document.body, { childList: true, subtree: true });

  // Side-aware hover via event delegation
  document.addEventListener('mousemove', function(e) {
    var wrapper = document.getElementById('pwzrswiper-container-wrapper');
    if (!wrapper || !wrapper.contains(e.target)) return;
    var prev = wrapper.querySelector('.pwzrswiper-btn-prev');
    var next = wrapper.querySelector('.pwzrswiper-btn-next');
    if (!prev || !next) return;
    var mid = wrapper.getBoundingClientRect().left + wrapper.getBoundingClientRect().width / 2;
    if (e.clientX < mid) {
      prev.style.setProperty('opacity', '1', 'important');
      next.style.setProperty('opacity', '0', 'important');
    } else {
      next.style.setProperty('opacity', '1', 'important');
      prev.style.setProperty('opacity', '0', 'important');
    }
  });

  document.addEventListener('mouseout', function(e) {
    var wrapper = document.getElementById('pwzrswiper-container-wrapper');
    if (!wrapper || !wrapper.contains(e.target)) return;
    if (e.relatedTarget && wrapper.contains(e.relatedTarget)) return;
    wrapper.querySelectorAll('.pwzrswiper-btn-prev, .pwzrswiper-btn-next').forEach(function(a) {
      a.style.setProperty('opacity', '0', 'important');
    });
  });


  // === Model Size Callout: overlay on first PDP image ===
  function getModelInfo(variantId) {
    var container = document.getElementById('model-size-callout-data');
    if (!container) return '';
    var div = container.querySelector('.ss-model-callout-info[data-variant-id="' + variantId + '"]');
    return div ? div.textContent.trim() : '';
  }

  function findFirstPdpSlide() {
    var pw = document.getElementById('pwzrswiper-container-wrapper');
    if (pw) {
      var s = pw.querySelector('.pwzrswiper-slide');
      if (s) return s;
    }
    var native = document.querySelector('.product-single__media-slider');
    if (native) {
      var s = native.querySelector('.product-single__media-slide:not(.media--hidden)')
            || native.querySelector('.product-single__media-slide');
      if (s) return s;
    }
    return null;
  }

  function setModelOverlay(text) {
    var firstSlide = findFirstPdpSlide();
    if (!firstSlide) return;

    firstSlide.style.position = 'relative';

    var overlay = firstSlide.querySelector('.ss-model-callout');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'ss-model-callout';
      overlay.style.cssText = [
        'position:absolute',
        'top:12px',
        'left:12px',
        'background:rgba(0,0,0,0.42)',
        'color:#fff',
        'font-size:11px',
        'letter-spacing:0.04em',
        'padding:5px 9px',
        'border-radius:3px',
        'pointer-events:none',
        'z-index:10',
        'opacity:0',
        'transition:opacity 0.35s ease',
        'max-width:calc(100% - 24px)',
        'line-height:1.4'
      ].join(';');
      firstSlide.appendChild(overlay);
    }

    if (text) {
      if (overlay.textContent !== text) {
        overlay.style.opacity = '0';
        overlay.textContent = text;
        requestAnimationFrame(function() {
          requestAnimationFrame(function() { overlay.style.opacity = '1'; });
        });
      } else {
        overlay.style.opacity = '1';
      }
    } else {
      overlay.style.opacity = '0';
    }
  }

  var _lastOverlayVariant = '';
  function updateModelOverlay() {
    var params = new URLSearchParams(window.location.search);
    var variantId = params.get('variant') || '';
    if (!variantId) {
      var input = document.querySelector('input[name="id"]');
      if (input) variantId = input.value;
    }
    if (variantId === _lastOverlayVariant && _lastOverlayVariant !== '') return;
    _lastOverlayVariant = variantId;
    setModelOverlay(getModelInfo(variantId));
    updateSizingAccordion(variantId);
  }

  // === Sizing & Fit accordion: swap in active variant's model_size_info ===
  function findSizingAccordion() {
    // Try stable ID prefix (women's templates with named block keys)
    var nodes = document.querySelectorAll('[id^="ProductAccordion--page-sizing-fit"]');
    for (var i = 0; i < nodes.length; i++) {
      var inner = nodes[i].querySelector('.product__accordion__inner');
      if (inner) return inner;
    }
    // Fallback: find by heading text (men's templates use random block IDs)
    var accordions = document.querySelectorAll('[id^="ProductAccordion"]');
    for (var i = 0; i < accordions.length; i++) {
      var heading = accordions[i].querySelector('summary, .product__accordion__title, button');
      if (heading && /sizing\s*&?\s*fit/i.test(heading.textContent)) {
        var inner = accordions[i].querySelector('.product__accordion__inner');
        if (inner) return inner;
      }
    }
    return null;
  }

  function getSelectedColor() {
    // Read the checked color swatch radio input (Palo Alto theme renders these with data-index="option1")
    var checked = document.querySelector('[data-index="option1"][data-single-option-selector]:checked');
    if (checked && checked.value) {
      // Strip liner/secondary info e.g. "Steel Blue | Digi-Dye Liner" → "Steel Blue"
      return checked.value.split('|')[0].trim().toLowerCase();
    }
    return '';
  }

  // Parse the rich text accordion HTML, return only lines whose parenthetical
  // color list contains the selected color. Returns null if no match found.
  function filterAccordionByColor(color, originalHtml) {
    if (!color) return null;
    // Strip liner/secondary option (e.g. "Steel Blue | Digi-Dye Liner" → "Steel Blue")
    var colorBase = color.split('|')[0];
    var norm = colorBase.trim().toLowerCase().replace(/[-_]/g, ' ');

    var temp = document.createElement('div');
    temp.innerHTML = originalHtml;

    function colorInParens(text) {
      var matches = text.match(/\(([^)]+)\)/g);
      if (!matches) return false;
      return matches.some(function(paren) {
        return paren.slice(1, -1).split(',').some(function(c) {
          var cn = c.trim().toLowerCase().replace(/[-_]/g, ' ');
          return cn === norm;
        });
      });
    }

    var hits = [];
    // Check <li> items
    var items = temp.querySelectorAll('li');
    if (items.length) {
      items.forEach(function(el) {
        if (colorInParens(el.textContent)) hits.push(el.outerHTML);
      });
      if (hits.length) return '<ul>' + hits.join('') + '</ul>';
    }
    // Check <p> items
    temp.querySelectorAll('p').forEach(function(el) {
      if (colorInParens(el.textContent)) hits.push(el.outerHTML);
    });
    return hits.length ? hits.join('') : null;
  }

  function updateSizingAccordion(variantId) {
    var inner = findSizingAccordion();
    if (!inner) return;
    if (!inner.hasAttribute('data-original-html')) {
      inner.setAttribute('data-original-html', inner.innerHTML);
    }
    var original = inner.getAttribute('data-original-html') || inner.innerHTML;

    // Priority 1: variant metafield
    var text = getModelInfo(variantId);
    if (text) {
      inner.innerHTML = '<div class="ss-sizing-fit-variant"><p>' + text.replace(/</g, '&lt;') + '</p></div>';
      return;
    }

    // Priority 2: filter rich text by color (read from checked swatch radio)
    var color = getSelectedColor();
    var filtered = filterAccordionByColor(color, original);
    if (filtered) {
      inner.innerHTML = '<div class="ss-sizing-fit-variant">' + filtered + '</div>';
      return;
    }

    // Fallback: restore original
    inner.innerHTML = original;
  }

  // === Preorder button text: CSS-only, zero race condition ===
  // Hengam adds class "hengam-preorder-button" to the ATC button for preorder variants.
  // We use CSS to hide the theme's text and show "Preorder" via ::after — no JS timing involved.
  // === Cart: hide wallet-cart-grid inside shadow DOM ===
  function hideCartWalletGrid() {
    document.querySelectorAll('shopify-accelerated-checkout-cart').forEach(function(acc) {
      if (!acc.shadowRoot || acc.dataset.gridHidden) return;
      var s = document.createElement('style');
      s.textContent = '.wallet-cart-grid { display: none !important; }';
      acc.shadowRoot.appendChild(s);
      acc.dataset.gridHidden = '1';
    });
  }

  function injectPreorderCSS() {
    if (document.getElementById('ss-preorder-btn')) return;
    var style = document.createElement('style');
    style.id = 'ss-preorder-btn';
    style.textContent = [
      'button.hengam-preorder-button [data-add-to-cart-text] {',
      '  visibility: hidden !important;',
      '  position: relative !important;',
      '}',
      'button.hengam-preorder-button [data-add-to-cart-text]::after {',
      '  content: "Pre-Order \u2022 10% off";',
      '  visibility: visible !important;',
      '  position: absolute !important;',
      '  left: 0 !important;',
      '  right: 0 !important;',
      '  text-align: center !important;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  injectPreorderCSS();

  // === Price badge: sync "Subscription" label to Hengam preorder state ===
  // The ATC button already flips to preorder text via the hengam-preorder-button class.
  // The price-off badge (data-price-off-type) has no equivalent check in theme.js —
  // it only branches on planSale/onSale — so it always shows "Subscription" for
  // subscription+preorder products. This keeps the badge in sync with the button.
  function syncPriceBadgeWithPreorder() {
    document.querySelectorAll('[data-add-to-cart]').forEach(function(btn) {
      var isPreorder = btn.classList.contains('hengam-preorder-button');
      var wrapper = btn.closest('[data-product], [data-quick-view-item]') || document;
      var priceOffType = wrapper.querySelector('[data-price-off-type]');
      if (!priceOffType) return;

      if (isPreorder) {
        if (!priceOffType.dataset.originalText) {
          priceOffType.dataset.originalText = priceOffType.textContent;
        }
        priceOffType.textContent = 'Preorder';
      } else if (priceOffType.dataset.originalText) {
        priceOffType.textContent = priceOffType.dataset.originalText;
        delete priceOffType.dataset.originalText;
      }
    });
  }

  document.addEventListener('theme:variant:change', syncPriceBadgeWithPreorder);
  setInterval(syncPriceBadgeWithPreorder, 300);

  // === Hide vanilla cart drawer so Rebuy Smart Cart loads without flash ===
  (function() {
    var s = document.createElement('style');
    s.id = 'ss-hide-vanilla-cart';
    s.textContent = '#cart-drawer { display: none !important; }';
    document.head.appendChild(s);
  })();

  // === Hide vanilla cart drawer so Rebuy Smart Cart loads without flash ===
  (function() {
    var s = document.createElement('style');
    s.id = 'ss-hide-vanilla-cart';
    s.textContent = '#cart-drawer { display: none !important; }';
    document.head.appendChild(s);
  })();

  setInterval(updateModelOverlay, 300);




  // === Tourney Short: hide entire Liner/Linerless section (temp fix, both lined + linerless PDPs) ===
  // DOM structure: [data-option="Liner"] → div[position:relative] → div.rio-width-fit-content (has label + buttons)
  function hideLinerSelector() {
    var linerContainer = document.querySelector('[data-option="Liner"]');
    if (!linerContainer || linerContainer.dataset.hidden) return;
    // Go up 2 levels: parent is the buttons wrapper, grandparent is the full section (label + buttons)
    var section = linerContainer.parentElement && linerContainer.parentElement.parentElement;
    if (section) {
      section.style.setProperty('display', 'none', 'important');
    } else {
      linerContainer.style.setProperty('display', 'none', 'important');
    }
    linerContainer.dataset.hidden = '1';
  }

  setTimeout(hideLinerSelector, 500);
  setTimeout(hideLinerSelector, 1500);


  // === Product card title cleanup: split into name + color on separate lines ===
  // Splits "Product Name - Color / Size / Liner" into two lines:
  //   Product Name
  //   Color  (size/liner stripped for multi-option products)
  function cleanProductCardTitles() {
    document.querySelectorAll('a.product-grid-item__title').forEach(function(el) {
      if (el.dataset.titleCleaned) return;
      var text = el.textContent.trim();
      var dashIdx = text.indexOf(' - ');
      if (dashIdx === -1) return;
      var productName = text.slice(0, dashIdx);
      var colorPart = text.slice(dashIdx + 3);
      // Strip size/liner for multi-option variants (e.g. "Steel Blue / S / Linerless")
      var slashIdx = colorPart.indexOf(' / ');
      if (slashIdx !== -1) {
        colorPart = colorPart.slice(0, slashIdx);
      }
      el.textContent = productName;
      var colorEl = document.createElement('span');
      colorEl.className = 'product-card-color-line';
      colorEl.textContent = colorPart;
      el.insertAdjacentElement('afterend', colorEl);
      el.dataset.titleCleaned = '1';
    });
  }

  cleanProductCardTitles();

  // Re-run for infinite scroll / swatch-triggered updates
  var _titleObserver = new MutationObserver(function() {
    cleanProductCardTitles();
  });
  var _grid = document.querySelector('[data-section-type="collection"]') || document.body;
  _titleObserver.observe(_grid, { childList: true, subtree: true });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


